import { memo, useCallback } from "react";
import { WorkspaceSelector } from "../../../components/WorkspaceSelector";
import { useAppData } from "../../../hooks";
import { workspaceApi } from "../../../services/workspaces";

type SuggestionWorkspaceSelector = {
  appId: string;
  userId: string;
};

export const SuggestionWorkspaceSelector = memo(({ appId, userId }: SuggestionWorkspaceSelector) => {
  const [workspaceId, setWorkspaceId] = useAppData<string>(appId, "workspaceId");

  const { data: workspaces = [], isLoading, isFetching, refetch } = workspaceApi.useGetWorkspacesQuery();

  const onSelectWorkspace = useCallback(
    (selectedOption: string) => {
      setWorkspaceId(selectedOption);
    },
    [setWorkspaceId]
  );

  const onRefreshWorkspaces = useCallback(() => {
    refetch();
  }, [refetch]);

  return (
    <WorkspaceSelector
      workspaces={workspaces}
      isLoading={isFetching || isLoading}
      selectedWorkspace={workspaceId}
      onSelectWorkspace={onSelectWorkspace}
      refreshWorkspaces={onRefreshWorkspaces}
    />
  );
});
